export default {
    "alpine heather": "#458075"
    ,"aqua": "#5F93B9"
    ,"aqua heather": "#49B3D4"
    ,"army": "#524E43"
    ,"ash": "#F6F8F9"
    ,"asphalt":"#5B5B5B"
    ,"athletic heather": "#B0AFB5"
    ,"atlantic":"#123135"
    ,"autumn":"#A75A36"
    ,"baby blue":"#B1C1D9"
    ,"basal grey": "#4D5A60"
    ,"basal gray": "#4D5A60"
    ,"berry":"#A74470"
    ,"black": "#000000"
    ,"black and grey": "#000000"
    ,"black heather":"#343434"
    ,"blue": "#0000FF"
    ,"blue heather": "#4C68BE"
    ,"blue storm":"#6D7371"
    ,"brick": "#9F2824"
    ,"brown":"#352B29"
    ,"burgundy": "#CA4D5A"
    ,"burnt orange":"#CE7C4B"
    ,"canvas red":"#7E2129"
    ,"canyon red": "#C15044"
    ,"cardinal":"#5F2327"
    ,"cardinal triblend": "#772B2F"
    ,"cargo green": "#2B4B35"
    ,"carolina blue":"#7BA6DE"
    ,"cascara red": "#FF2929"
    ,"charcoal": "#333F48"
    ,"charcoal heather": "#333F48"
    ,"charity pink":"#E77598"
    ,"cherry blossom pink": "#F5CEC8"
    ,"chestnut":"#A2705A"
    ,"citron":"#E6E6DA"
    ,"clay":"#9D432C"
    ,"coastal teal": "#429394"
    ,"columbia blue":"#2967A4"
    ,"cool blue": "#01426A"
    ,"cool violet": "#6E628B"
    ,"coral": "#E96951"
    ,"cream": "#D7D5C6"
    ,"dark grey": "#323033"
    ,"dark grey heather": "#434141"
    ,"dark lavender": "#A7A1C5"
    ,"dark olive": "#36362A"
    ,"dark heather": "#4E5256"
    ,"dark pink": "#E67ABC"
    ,"deep heather": "#716E6A"
    ,"deep teal": "#324550"
    ,"dtg black": "#000000"
    ,"dtg dark grey": "#282828"
    ,"dtg white": "#EFEFEF"
    ,"dust": "#DAD0C5"
    ,"dusty blue": "#A4BDB3"
    ,"dusty rose": "#CC8F94"
    ,"electric blue": "#006EB3"
    ,"evergreen": "#385038"
    ,"forest": "#27342E"
    ,"forest green": "#3E4C3F" 
    ,"french vanilla": "#F1E19B"
    ,"fuchsia": "#B82658"
    ,"gray": "#7C7E7F"
    ,"gray heather": "#7C7E7F"
    ,"gold": "#EFAE3C"
    ,"green": "#008000"
    ,"grey": "#7C7E7F"
    ,"grey acid fleece": "#79717E"
    ,"grey heather": "#898D8D"
    ,"grey triblend": "#8B8D8E"
    ,"harvest gold": "#DBAE49"
    ,"heather blue lagoon": "#86A1A9"
    ,"heather charity pink": "#FB7496"
    ,"heather columbia blue": "#5B7BC8"
    ,"heather deep teal": "#547380"
    ,"heather dust": "#DFD5C8"
    ,"heather forest": "#4B5548"
    ,"heather maroon": "#5C3C3D"
    ,"heather mauve": "#BA7474"
    ,"heather mustard": "#E39E27"
    ,"heather navy": "#444860"
    ,"heather olive": "#64583E"
    ,"heather red": "#D7444D"
    ,"heather sand dune": "#E6C09D"
    ,"heather slate": "#525961"
    ,"heather stone": "#AAA899"
    ,"heather team purple": "#694D67"
    ,"heather true royal": "#5D6BAB"
    ,"home blue": "#6D9FA5"
    ,"indigo": "#4B0082"
    ,"irish heather": "#00B373"
    ,"khaki": "#F0D3B2"
    ,"kelly": "#325837"
    ,"lavender blue": "#8A92B3"
    ,"lavender dust": "#D7D0D9"
    ,"leaf": "#5D7746"
    ,"lemon heather": "#FFE885"
    ,"light blue": "#BEC2CB"
    ,"light violet": "#A898A2"
    ,"light pink": "#F9B3DB"
    ,"lilac": "#D3ADCA"
    ,"lime green": "#9EB965"
    ,"lost valley": "#90B0BC"
    ,"mango": "#e9ae4a"
    ,"maize yellow": "#F0D86A"
    ,"marine": "#00809E"
    ,"maroon": "#572D35"
    ,"maroon heather": "#7D4E5B"
    ,"matte black": "#000000"
    ,"matte grey": "#9D9D9D"
    ,"matte white": "#FFFFFF"
    ,"mauve": "#AF796B"
    ,"military green": "#515441"
    ,"military heather": "#535435"
    ,"mint": "#B4DCB5"
    ,"mint chip": "#C1DBD2"
    ,"mustard": "#D29E33"
    ,"natural": "#FADEBD"
    ,"navy": "#171828"
    ,"navy blue": "#566172"
    ,"navy heather": "#3C5165"
    ,"navy triblend": "#3A4656"
    ,"night hike": "#2F2627"
    ,"pow day": "#E7E8EA"
    ,"sierra sippin": "#36403B"
    ,"travelin'": "#C6AF99"
    ,"get far out": "#A1CAC8"
    ,"ocean blue": "#74AFCE"
    ,"olive": "#474D23"
    ,"orange": "#FA6A32"
    ,"orchid": "#D5A3A6"
    ,"oxblood black": "#221316"
    ,"peach": "#F4C2A9"
    ,"pebble": "#A89694"
    ,"peri twinkle": "#C6B4E3"
    ,"periwinkle": "#C6B4E3"
    ,"pine": "#788976"
    ,"pink": "#FCC3C4"
    ,"poppy": "#FE4130"
    ,"prismatic teal": "#004E54"
    ,"purple": "#875B88"
    ,"purple heather": "#564770"
    ,"red": "#BE2C2D"
    ,"red and black": "#BE2C2D"
    ,"red heather": "#DD5061"
    ,"really red": "#9C182F"
    ,"royal blue": "#2A6AB1"
    ,"royal purple": "#7A548D"
    ,"rust": "#792A1B"
    ,"sage": "#96A794"
    ,"sand": "#E5D6C2"
    ,"sand dune": "#EFCFA9"
    ,"sandstone white": "#F2EDD7"
    ,"seaglass green": "#C0DACA"
    ,"sienna": "#8A5443"
    ,"silver": "#D8D7D3"
    ,"slate": "#254A5D"
    ,"smoke green": "#80958E"
    ,"soft cream": "#D1BF97"
    ,"soft pink": "#F1CBC9"
    ,"solid athletic grey": "#CAC9C7"
    ,"spark yellow": "#EEE14D"
    ,"splash zone": "#4EC2CF"
    ,"sport grey": "#ABB0B8"
    ,"spring green": "#D3E2B7"
    ,"steel blue": "#676D77"
    ,"stone blue": "#394F66"
    ,"storm": "#82767A"
    ,"strobe": "#E1E26B"
    ,"sunset": "#E6A181"
    ,"synthetic green": "#6CE798"
    ,"tan": "#B6A387"
    ,"teal": "#71AC96"
    ,"team navy": "#231D4F"
    ,"team purple": "#3C206B"
    ,"terracotta": "#E6A994"
    ,"terracota": "#E6A994"
    ,"thousand hills pink": "#E1CEC5"
    ,"tidal blue": "#202945"
    ,"tiger camo": "#575A44"
    ,"thyme": "#A2A192"
    ,"toast": "#BE7E4E"
    ,"true royal": "#3A51A1"
    ,"turquoise": "#81B4C5"
    ,"vintage black": "#111113"
    ,"vintage brown": "#7E6655"
    ,"vintage navy": "#455D6B"
    ,"vintage white": "#EAE5E2"
    ,"violet": "#a171ce"
    ,"warm pink": "#FCDEE0"
    ,"white": "#F6F5F9"
    ,"yellow": "#F0D552"
}